var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "4",
      "height": "78",
      "viewBox": "0 0 4 78",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_67_3521",
      "maskUnits": "userSpaceOnUse",
      "x": "0",
      "y": "0",
      "width": "4",
      "height": "79"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 1.99414L2 76.9941",
      "stroke": "#F58220",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-dasharray": "5 5"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask0_67_3521)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 0.812988L2 75.813",
      "stroke": "#F2F2F7",
      "stroke-width": "2.5",
      "stroke-linecap": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M2 1.99414L2 19.8513",
      "stroke": "#F58220",
      "stroke-width": "2.5",
      "stroke-linecap": "round"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }